// Venues store their greens in one of two shapes: rink-level
// { name, rinks: [{ rink, active }] }, written by the venue editor, or flat
// { name, rink_count }, carried by older and imported data. A pattern has to
// follow the selected club in both shapes, otherwise a seven-rink green
// silently becomes the six-rink default.

export const DEFAULT_GREENS = 3;
export const DEFAULT_RINKS_PER_GREEN = 6;

export const clampPositiveInt = (value, fallback) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback;
  }

  return Math.floor(parsed);
};

const alphaLabel = (index) => {
  return String.fromCharCode(65 + (index % 26));
};

const readGreenRinks = (green) => {
  const sourceRinks = Array.isArray(green?.rinks) ? green.rinks : [];

  if (sourceRinks.length > 0) {
    return sourceRinks.map((rink, rinkIdx) => ({
      rink: Number(rink?.rink) || rinkIdx + 1,
      active: rink?.active !== false
    }));
  }

  const rinkCount = clampPositiveInt(green?.rink_count, DEFAULT_RINKS_PER_GREEN);

  return Array.from({ length: rinkCount }, (_, rinkIdx) => ({
    rink: rinkIdx + 1,
    active: true
  }));
};

export const normalizeVenueToLocation = (venue, fallbackGreensCount, fallbackRinksPerGreen) => {
  const venueId = String(venue?.id || 'custom-club');
  const venueName = String(venue?.name || 'Selected Club');
  const sourceGreens = Array.isArray(venue?.greens) ? venue.greens : [];

  let greens = [];
  if (sourceGreens.length > 0) {
    greens = sourceGreens.map((green, greenIdx) => ({
      name: String(green?.name || `Green ${alphaLabel(greenIdx)}`),
      rinks: readGreenRinks(green)
    }));
  } else {
    const greensCount = clampPositiveInt(fallbackGreensCount, DEFAULT_GREENS);
    const rinksPerGreen = clampPositiveInt(fallbackRinksPerGreen, DEFAULT_RINKS_PER_GREEN);

    greens = Array.from({ length: greensCount }, (_, greenIdx) => ({
      name: `Green ${alphaLabel(greenIdx)}`,
      rinks: Array.from({ length: rinksPerGreen }, (_, rinkIdx) => ({
        rink: rinkIdx + 1,
        active: true
      }))
    }));
  }

  return {
    id: venueId,
    name: venueName,
    greens
  };
};

export const getGreenRinkOptions = (greenLocations = []) => {
  const options = [];

  (Array.isArray(greenLocations) ? greenLocations : []).forEach((location) => {
    (location?.greens || []).forEach((green) => {
      readGreenRinks(green).forEach((rink) => {
        if (rink.active) {
          options.push({
            label: `${location.name} - ${green.name}${rink.rink}`,
            green: green.name,
            rink: rink.rink,
            locationId: location.id,
            locationName: location.name
          });
        }
      });
    });
  });

  return options;
};
